import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomLoginFormComponent } from './custom-login-form/custom-login-form.component';
import { FormErrorsModule } from '@spartacus/storefront';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { UrlModule, I18nModule, provideDefaultConfig, CmsConfig, NotAuthGuard } from '@spartacus/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { LoginBreadcrumbComponent } from './login-breadcrumb/login-breadcrumb.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        UrlModule,
        I18nModule,
        FormErrorsModule,
        SharedModule,
        CustomLoginFormComponent, LoginBreadcrumbComponent
    ],
    providers: [
        // tslint:disable-next-line:no-angle-bracket-type-assertion
        provideDefaultConfig(<CmsConfig>{
            cmsComponents: {
                ReturningCustomerLoginComponent: {
                    component: CustomLoginFormComponent,
                    guards: [NotAuthGuard],
                },
            },
        }),
    ],
    exports: [CustomLoginFormComponent]
})
export class CustomLoginFormModule { }
